import script from "./app-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-layout.vue?vue&type=script&lang=ts&setup=true"

import "./app-layout.vue?vue&type=style&index=0&id=53538c58&lang=scss"

export default script